import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getApiUrl } from '../config/api';
import * as XLSX from 'xlsx';
import './GestionProducto.css';

const formatearFecha = (fecha) => {
    if (!fecha) return '';
    const [year, month, day] = fecha.split('-');
    return `${day}/${month}/${year}`;
};

const obtenerFechaHoy = () => new Date().toISOString().split('T')[0];

const formatearNumero = (valor) => {
    if (valor == null) return '0,00';
    return Number(valor).toLocaleString('es-PY', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

function BLiqRepar({ usuario }) {
    const [rendiciones, setRendiciones] = useState([]);
    const [rendicionesFiltradas, setRendicionesFiltradas] = useState([]);
    const [busqueda, setBusqueda] = useState('');
    const [modalAbierto, setModalAbierto] = useState(false);

    // Datos selectores
    const [empleados, setEmpleados] = useState([]);
    const [sucursales, setSucursales] = useState([]);
    const [depositos, setDepositos] = useState([]);
    const [nrepartoDisponibles, setNrepartoDisponibles] = useState([]);

    // Selectores activos
    const [empleadoSeleccionado, setEmpleadoSeleccionado] = useState(null);
    const [dropdownEmpleadoAbierto, setDropdownEmpleadoAbierto] = useState(false);
    const [busquedaEmpleado, setBusquedaEmpleado] = useState('');
    const dropdownEmpleadoRef = useRef(null);

    // Selectores banco y tarjeta (para sub-formularios de cheque/tarjeta)
    const [bancoSeleccionado, setBancoSeleccionado] = useState(null);
    const [dropdownBancoAbierto, setDropdownBancoAbierto] = useState(false);
    const [busquedaBanco, setBusquedaBanco] = useState('');
    const dropdownBancoRef = useRef(null);

    const [tarjetaSeleccionada, setTarjetaSeleccionada] = useState(null);
    const [dropdownTarjetaAbierto, setDropdownTarjetaAbierto] = useState(false);
    const [busquedaTarjeta, setBusquedaTarjeta] = useState('');
    const dropdownTarjetaRef = useRef(null);

    const [formulario, setFormulario] = useState({
        nreparto: '', idEmpleado: '', fecha: obtenerFechaHoy(), idSucursal: '', idDeposito: '', obs: '', bEstado: ' '
    });

    // Modal Rendicion - carga manual de valores ren_
    const [modalRendicion, setModalRendicion] = useState(false);
    const [rendRow, setRendRow] = useState(null);
    const [rendTot, setRendTot] = useState({});
    const [rendForm, setRendForm] = useState({});
    const [guardandoRend, setGuardandoRend] = useState(false);

    // Modal Caja - registro de pagos
    const [modalCajaAbierto, setModalCajaAbierto] = useState(false);
    const [rendicionActiva, setRendicionActiva] = useState(null);
    const [facturasPendientes, setFacturasPendientes] = useState([]);
    const [pagosRegistrados, setPagosRegistrados] = useState([]);
    const [facturaPagoSeleccionada, setFacturaPagoSeleccionada] = useState(null);
    const [tipoPago, setTipoPago] = useState('EFE');
    const [montoPago, setMontoPago] = useState(0);

    // Datos del cheque (cuando tipo de pago es CHE)
    const [bancos, setBancos] = useState([]);
    const [cheque, setCheque] = useState({
        idBanco: '', nrocheque: '', fechaCheque: obtenerFechaHoy(), vencimientoCheque: obtenerFechaHoy(), obsCheque: ''
    });

    // Datos de la tarjeta (cuando tipo de pago es TC)
    const [tarjetas, setTarjetas] = useState([]);
    const [tarjeta, setTarjeta] = useState({
        idTarjeta: '', nroboleta: '', fechaTarjeta: obtenerFechaHoy(), obsTarjeta: ''
    });

    // Datos de NCR (cuando tipo de pago es NCR)
    const [ncrDisponibles, setNcrDisponibles] = useState([]);
    const [ncrSeleccionada, setNcrSeleccionada] = useState(null);
    const [dropdownNcrAbierto, setDropdownNcrAbierto] = useState(false);
    const [busquedaNcr, setBusquedaNcr] = useState('');
    const dropdownNcrRef = useRef(null);

    // Datos de RETENCION (cuando tipo de pago es RET)
    const [retencion, setRetencion] = useState({
        nretencion: '', timbrado: '', venctimb: '', fecha: obtenerFechaHoy(),
        serie: 1, tipoDoc: 'RET',
        valorSiniva: 0, iva: 0, valorTotal: 0,
        pocReten: 30, monReten: 0,
        pocRenta: 0, monRenta: 0,
        totalReten: 0, obs: ''
    });

    // Paginacion
    const [paginaActual, setPaginaActual] = useState(1);
    const [itemsPorPagina, setItemsPorPagina] = useState(10);

    useEffect(() => { cargarRendiciones(); cargarDatosSelectores(); }, []);
    useEffect(() => { filtrarRendiciones(); }, [busqueda, rendiciones]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownEmpleadoRef.current && !dropdownEmpleadoRef.current.contains(event.target)) setDropdownEmpleadoAbierto(false);
            if (dropdownBancoRef.current && !dropdownBancoRef.current.contains(event.target)) setDropdownBancoAbierto(false);
            if (dropdownTarjetaRef.current && !dropdownTarjetaRef.current.contains(event.target)) setDropdownTarjetaAbierto(false);
            if (dropdownNcrRef.current && !dropdownNcrRef.current.contains(event.target)) setDropdownNcrAbierto(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const cargarRendiciones = async () => {
        try { const r = await axios.get(getApiUrl('/api/bliqrepar')); setRendiciones(r.data); setRendicionesFiltradas(r.data); }
        catch (e) { console.error('Error:', e); alert('Error al cargar rendiciones'); }
    };

    const cargarDatosSelectores = async () => {
        try {
            const [r1, r2, r3, r4, r5, r6] = await Promise.all([
                axios.get(getApiUrl('/api/empleados')),
                axios.get(getApiUrl('/api/sucursales')),
                axios.get(getApiUrl('/api/depositos')),
                axios.get(getApiUrl('/api/bliqrepar/nreparto-disponibles')),
                axios.get(getApiUrl('/api/tbco')),
                axios.get(getApiUrl('/api/ttarjeta'))
            ]);
            setEmpleados(r1.data); setSucursales(r2.data); setDepositos(r3.data); setNrepartoDisponibles(r4.data);
            setBancos(r5.data); setTarjetas(r6.data);
        } catch (e) { console.error('Error selectores:', e); }
    };

    const filtrarRendiciones = () => {
        if (!busqueda) { setRendicionesFiltradas(rendiciones); setPaginaActual(1); return; }
        setRendicionesFiltradas(rendiciones.filter(r =>
            r.nreparto?.toString().includes(busqueda) ||
            r.idLiquidacion?.toString().includes(busqueda) ||
            r.obs?.toLowerCase().includes(busqueda.toLowerCase())
        ));
        setPaginaActual(1);
    };

    const filtrarEmpleados = (b) => !b ? empleados.slice(0, 100) : empleados.filter(e => e.idEmpleado?.toString().includes(b) || e.nombre?.toLowerCase().includes(b.toLowerCase()));
    const seleccionarEmpleado = (e) => { setEmpleadoSeleccionado(e); setFormulario(f => ({...f, idEmpleado: e.idEmpleado})); setBusquedaEmpleado(''); setDropdownEmpleadoAbierto(false); };

    const seleccionarNreparto = (nr) => {
        setFormulario(f => ({
            ...f, nreparto: nr.nreparto,
            fecha: nr.fecha || obtenerFechaHoy(),
            idSucursal: nr.id_sucursal || f.idSucursal,
            idDeposito: nr.id_deposito || f.idDeposito,
            idEmpleado: nr.id_empleado || f.idEmpleado
        }));
        if (nr.id_empleado) { const e = empleados.find(e => e.idEmpleado === nr.id_empleado); if (e) setEmpleadoSeleccionado(e); }
    };

    const abrirModalNuevo = () => {
        setFormulario({ nreparto: '', idEmpleado: '', fecha: obtenerFechaHoy(), idSucursal: '', idDeposito: '', obs: '', bEstado: ' ' });
        setEmpleadoSeleccionado(null);
        axios.get(getApiUrl('/api/bliqrepar/nreparto-disponibles')).then(r => setNrepartoDisponibles(r.data)).catch(e => console.error(e));
        setModalAbierto(true);
    };

    const cerrarModal = () => { setModalAbierto(false); };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formulario.nreparto) { alert('Debe seleccionar un numero de reparto'); return; }

        try {
            await axios.post(getApiUrl('/api/bliqrepar'), formulario);
            alert('Rendicion creada exitosamente');
            cargarRendiciones();
            cerrarModal();
        } catch (error) {
            const msg = error.response?.data || 'Error al guardar';
            alert(typeof msg === 'string' ? msg : 'Error al guardar');
        }
    };

    const cerrarPlanilla = async (r) => {
        if (r.bEstado === 'C') { alert('La planilla ya esta cerrada'); return; }
        if (!window.confirm(
            'Esta seguro de CERRAR la planilla del reparto ' + r.nreparto + '?\n\n' +
            'Una vez cerrada NO podra:\n' +
            '  - Registrar mas pagos en caja\n' +
            '  - Eliminar la rendicion\n' +
            '  - Agregar facturas a la planilla'
        )) return;
        try {
            await axios.put(getApiUrl('/api/bliqrepar/cerrar'), null, {
                params: { idLiquidacion: r.idLiquidacion, nreparto: r.nreparto }
            });
            alert('Planilla cerrada correctamente'); cargarRendiciones();
        } catch (error) {
            const msg = error.response?.data || 'Error al cerrar planilla';
            alert(typeof msg === 'string' ? msg : 'Error al cerrar planilla');
        }
    };

    // ====== RENDICION MANUAL (campos ren_) ======
    // (label, clave ren en form/PUT camelCase, clave tot/ren en respuesta snake_case)
    const RENDICION_CAMPOS = [
        { label: 'Efectivo',            ren: 'renEfectivo', renDb: 'ren_efectivo', tot: 'tot_efectivo' },
        { label: 'Cheque',              ren: 'renCheque',   renDb: 'ren_cheque',   tot: 'tot_cheque' },
        { label: 'Cta Cte',             ren: 'renCtacte',   renDb: 'ren_ctacte',   tot: 'tot_ctacte' },
        { label: 'Notas de Crédito',    ren: 'renNotacr',   renDb: 'ren_notacr',   tot: 'tot_notacr' },
        { label: 'Otros',               ren: 'renOtros',    renDb: 'ren_otros',    tot: 'tot_otros' },
        { label: 'Anulados',            ren: 'renAnulado',  renDb: 'ren_anulado',  tot: 'tot_anulado' },
        { label: 'Retenciones',         ren: 'renRet',      renDb: 'ren_ret',      tot: 'tot_ret' },
        { label: 'Vuelto',              ren: 'renVuelto',   renDb: 'ren_vuelto',   tot: 'tot_vuelto' },
        { label: 'Adelanto de Cliente', ren: 'renAdelanto', renDb: 'ren_adelanto', tot: 'tot_adelanto' },
        { label: 'Dif Caja',            ren: 'renDifcaja',  renDb: 'ren_difcaja',  tot: 'tot_difcaja' },
        { label: 'Tarjeta',             ren: 'renTc',       renDb: 'ren_tc',       tot: 'tot_tc' }
    ];

    const abrirModalRendicion = async (r) => {
        try {
            const resp = await axios.get(getApiUrl('/api/bliqrepar/rendicion'), {
                params: { idLiquidacion: r.idLiquidacion, nreparto: r.nreparto }
            });
            const d = resp.data || {};
            const tot = {}; const form = {};
            RENDICION_CAMPOS.forEach(c => {
                tot[c.tot] = Number(d[c.tot]) || 0;
                form[c.ren] = Number(d[c.renDb]) || 0;
            });
            setRendTot(tot);
            setRendForm(form);
            setRendRow(r);
            setModalRendicion(true);
        } catch (e) {
            console.error('Error cargando rendicion:', e);
            alert('No se pudo cargar la rendición: ' + (e.response?.data || e.message));
        }
    };

    const setRendCampo = (ren, valor) => setRendForm(prev => ({ ...prev, [ren]: valor }));

    // Igualar la rendición a los valores calculados
    const igualarRendicion = () => {
        const form = {};
        RENDICION_CAMPOS.forEach(c => { form[c.ren] = rendTot[c.tot] || 0; });
        setRendForm(form);
    };

    // Diferencia según la fórmula del reporte:
    // (sum ren core) - (sum tot core) + tot_difcaja ; core = efe,che,cta,ncr,otros,anul,ret
    const calcularDiferenciaRend = () => {
        const core = ['renEfectivo', 'renCheque', 'renCtacte', 'renNotacr', 'renOtros', 'renAnulado', 'renRet'];
        const coreTot = ['tot_efectivo', 'tot_cheque', 'tot_ctacte', 'tot_notacr', 'tot_otros', 'tot_anulado', 'tot_ret'];
        const sumRen = core.reduce((s, k) => s + (Number(rendForm[k]) || 0), 0);
        const sumTot = coreTot.reduce((s, k) => s + (Number(rendTot[k]) || 0), 0);
        return sumRen - sumTot + (Number(rendTot['tot_difcaja']) || 0);
    };

    const guardarRendicion = async () => {
        if (!rendRow) return;
        setGuardandoRend(true);
        try {
            const body = {};
            RENDICION_CAMPOS.forEach(c => { body[c.ren] = Number(rendForm[c.ren]) || 0; });
            await axios.put(getApiUrl('/api/bliqrepar/rendicion'), body, {
                params: { idLiquidacion: rendRow.idLiquidacion, nreparto: rendRow.nreparto }
            });
            setModalRendicion(false);
            alert('Rendición guardada.');
            cargarRendiciones();
        } catch (e) {
            console.error('Error guardando rendicion:', e);
            alert('No se pudo guardar: ' + (e.response?.data || e.message));
        } finally {
            setGuardandoRend(false);
        }
    };

    // ====== CAJA - REGISTRO DE PAGOS ======
    const TIPOS_PAGO = [
        { codigo: 'EFE', nombre: 'Efectivo', campo: 'monEfectivo' },
        { codigo: 'CHE', nombre: 'Cheque', campo: 'monCheque' },
        { codigo: 'CC', nombre: 'Cuenta Corriente', campo: 'monCtacte' },
        { codigo: 'TC', nombre: 'Tarjeta de Credito', campo: 'monTc' },
        { codigo: 'NCR', nombre: 'Nota de Credito', campo: 'monNotacr' },
        { codigo: 'OTR', nombre: 'Otros', campo: 'monOtros' },
        { codigo: 'RET', nombre: 'Retencion', campo: 'monReten' },
        { codigo: 'DC', nombre: 'Diferencia de Caja', campo: 'monDifcaja' },
        { codigo: 'ADL', nombre: 'Adelanto', campo: 'monAdelanto' },
        { codigo: 'VTO', nombre: 'Vuelto', campo: 'monVuelto' }
    ];

    const abrirModalCaja = async (r) => {
        if (r.bEstado === 'C') { alert('No se pueden registrar pagos en una rendicion cerrada'); return; }
        setRendicionActiva(r);
        setFacturaPagoSeleccionada(null);
        setTipoPago('EFE'); setMontoPago(0);
        try {
            const [rPend, rPagos] = await Promise.all([
                axios.get(getApiUrl('/api/bliqrepard/facturas-pendientes'), { params: { nreparto: r.nreparto } }),
                axios.get(getApiUrl('/api/bliqrepard'), { params: { idLiquidacion: r.idLiquidacion } })
            ]);
            setFacturasPendientes(rPend.data);
            setPagosRegistrados(rPagos.data);
        } catch (e) {
            console.error('Error:', e);
            alert('Error al cargar facturas pendientes');
            return;
        }
        setModalCajaAbierto(true);
    };

    const recargarFacturasYPagos = async () => {
        try {
            const [rPend, rPagos] = await Promise.all([
                axios.get(getApiUrl('/api/bliqrepard/facturas-pendientes'), { params: { nreparto: rendicionActiva.nreparto } }),
                axios.get(getApiUrl('/api/bliqrepard'), { params: { idLiquidacion: rendicionActiva.idLiquidacion } })
            ]);
            setFacturasPendientes(rPend.data);
            setPagosRegistrados(rPagos.data);
            // Si la factura activa ya no tiene saldo, deseleccionar
            if (facturaPagoSeleccionada) {
                const sigue = rPend.data.find(f => f.timbrado === facturaPagoSeleccionada.timbrado &&
                    f.nfactura === facturaPagoSeleccionada.nfactura && f.tipo_doc === facturaPagoSeleccionada.tipo_doc);
                if (!sigue) { setFacturaPagoSeleccionada(null); setMontoPago(0); }
                else setFacturaPagoSeleccionada(sigue);
            }
        } catch (e) { console.error(e); }
    };

    const seleccionarFacturaPago = async (f) => {
        setFacturaPagoSeleccionada(f);
        // Usar el monto realmente disponible (mon_total - pagos previos) en vez del saldo
        const disponible = Number(f.disponible) || Number(f.saldo) || 0;
        setMontoPago(disponible);
        // Resetear datos de cheque
        setCheque({ idBanco: '', nrocheque: '', fechaCheque: obtenerFechaHoy(), vencimientoCheque: obtenerFechaHoy(), obsCheque: '' });
        setBancoSeleccionado(null); setBusquedaBanco('');
        // Resetear datos de tarjeta
        setTarjeta({ idTarjeta: '', nroboleta: '', fechaTarjeta: obtenerFechaHoy(), obsTarjeta: '' });
        setTarjetaSeleccionada(null); setBusquedaTarjeta('');
        // Resetear NCR y cargar NCR disponibles del cliente
        setNcrSeleccionada(null); setBusquedaNcr(''); setNcrDisponibles([]);
        if (f.id_cliente) {
            try {
                const r = await axios.get(getApiUrl('/api/bliqrepard/ncredito-disponibles'), { params: { idCliente: f.id_cliente } });
                setNcrDisponibles(r.data);
            } catch (e) { console.error('Error NCR disponibles:', e); }
        }
        // Resetear RETENCION precargando datos desde la factura
        const valorTotal = Number(f.mon_total) || Number(f.disponible) || 0;
        const iva = Number(f.mon_iva) || 0;
        const valorSiniva = valorTotal - iva;
        setRetencion({
            nretencion: '', timbrado: '', venctimb: '', fecha: obtenerFechaHoy(),
            serie: 1, tipoDoc: 'RET',
            valorSiniva, iva, valorTotal,
            pocReten: 30, monReten: 0,
            pocRenta: 0, monRenta: 0,
            totalReten: 0, obs: ''
        });
    };

    // ===== RETENCION =====
    const recalcularRetencion = (campos) => {
        // Recalcula IVA retenido = iva * pocReten/100
        // Recalcula Renta retenida = valorSiniva * pocRenta/100
        const r = { ...retencion, ...campos };
        const ivaBase = Number(r.iva) || 0;
        const sinIvaBase = Number(r.valorSiniva) || 0;
        const pocR = Number(r.pocReten) || 0;
        const pocRenta = Number(r.pocRenta) || 0;
        if (!('monReten' in campos)) {
            r.monReten = Math.round((ivaBase * pocR) / 100);
        }
        if (!('monRenta' in campos)) {
            r.monRenta = Math.round((sinIvaBase * pocRenta) / 100);
        }
        r.totalReten = Number(r.monReten) + Number(r.monRenta);
        setRetencion(r);
        // Sincronizar el monto del pago automaticamente con el total retenido
        if (tipoPago === 'RET') {
            setMontoPago(r.totalReten);
        }
    };

    // Filtros y selectores de banco y tarjeta
    const filtrarBancos = (b) => !b ? bancos : bancos.filter(x => x.idBco?.toLowerCase().includes(b.toLowerCase()) || x.nomBco?.toLowerCase().includes(b.toLowerCase()));
    const seleccionarBanco = (b) => {
        setBancoSeleccionado(b);
        setCheque(c => ({...c, idBanco: b.idBco}));
        setBusquedaBanco(''); setDropdownBancoAbierto(false);
    };

    const filtrarTarjetas = (b) => !b ? tarjetas : tarjetas.filter(x => x.idTarjeta?.toLowerCase().includes(b.toLowerCase()) || x.nomTarjeta?.toLowerCase().includes(b.toLowerCase()));
    const seleccionarTarjetaSel = (t) => {
        setTarjetaSeleccionada(t);
        setTarjeta(tr => ({...tr, idTarjeta: t.idTarjeta}));
        setBusquedaTarjeta(''); setDropdownTarjetaAbierto(false);
    };

    const filtrarNCR = (b) => !b ? ncrDisponibles : ncrDisponibles.filter(n => n.notacredito?.toString().includes(b) || n.timbrado?.includes(b) || n.comprobante?.toLowerCase().includes(b.toLowerCase()));
    const seleccionarNCR = (n) => {
        setNcrSeleccionada(n);
        setBusquedaNcr(''); setDropdownNcrAbierto(false);
        // Sugerir monto: el menor entre el saldo de la NCR y el disponible de la factura
        const saldoNCR = Number(n.saldo) || 0;
        const dispFactura = Number(facturaPagoSeleccionada?.disponible) || 0;
        setMontoPago(Math.min(saldoNCR, dispFactura));
    };

    const registrarPago = async () => {
        if (!facturaPagoSeleccionada) { alert('Seleccione una factura'); return; }
        if (!tipoPago) { alert('Seleccione un tipo de pago'); return; }
        if (montoPago <= 0 && !['NCR', 'VTO', 'NUL'].includes(tipoPago)) { alert('El monto debe ser mayor a 0'); return; }

        const disponible = Number(facturaPagoSeleccionada.disponible) || Number(facturaPagoSeleccionada.saldo) || 0;
        if (montoPago > disponible && !['NCR', 'VTO'].includes(tipoPago)) {
            alert('El monto (' + montoPago.toLocaleString('es-PY') + ') excede el disponible de la factura (' + disponible.toLocaleString('es-PY') + ')');
            return;
        }

        const tp = TIPOS_PAGO.find(t => t.codigo === tipoPago);
        const f = facturaPagoSeleccionada;

        const pago = {
            idLiquidacion: rendicionActiva.idLiquidacion,
            boca: f.boca,
            tipoDoc: f.tipo_doc,
            nfactura: f.nfactura,
            idTpago: tipoPago,
            timbrado: f.timbrado,
            fecha: rendicionActiva.fecha,
            idCliente: f.id_cliente,
            nreparto: rendicionActiva.nreparto,
            idSucursal: f.id_sucursal,
            idDeposito: rendicionActiva.idDeposito,
            cambio: Number(f.cambio) || 1,
            monEfectivo: 0, monCheque: 0, monCtacte: 0, monTc: 0,
            monNotacr: 0, monOtros: 0, monAnulado: 0,
            monReten: 0, monVuelto: 0, monAdelanto: 0, monDifcaja: 0,
            bEstado: ' '
        };
        // Asignar el monto al campo correspondiente
        if (tp && tp.campo) pago[tp.campo] = montoPago;

        try {
            if (tipoPago === 'CHE') {
                // Validar datos del cheque
                if (!cheque.idBanco) { alert('Debe seleccionar un banco para el cheque'); return; }
                if (!cheque.nrocheque) { alert('Debe ingresar el numero de cheque'); return; }
                if (!cheque.vencimientoCheque) { alert('Debe ingresar el vencimiento del cheque'); return; }

                await axios.post(getApiUrl('/api/bliqrepard/con-cheque'), {
                    pago,
                    idBanco: cheque.idBanco,
                    nrocheque: Number(cheque.nrocheque),
                    fechaCheque: cheque.fechaCheque,
                    vencimientoCheque: cheque.vencimientoCheque,
                    montoCheque: montoPago,
                    obsCheque: cheque.obsCheque
                });
            } else if (tipoPago === 'TC') {
                // Validar datos de la tarjeta
                if (!tarjeta.idTarjeta) { alert('Debe seleccionar una tarjeta'); return; }
                if (!tarjeta.nroboleta) { alert('Debe ingresar el numero de boleta'); return; }

                await axios.post(getApiUrl('/api/bliqrepard/con-tarjeta'), {
                    pago,
                    idTarjeta: tarjeta.idTarjeta,
                    nroboleta: Number(tarjeta.nroboleta),
                    fechaTarjeta: tarjeta.fechaTarjeta,
                    montoTarjeta: montoPago,
                    obsTarjeta: tarjeta.obsTarjeta
                });
            } else if (tipoPago === 'NCR') {
                // Validar NCR seleccionada
                if (!ncrSeleccionada) { alert('Debe seleccionar una nota de credito'); return; }
                if (montoPago > Number(ncrSeleccionada.saldo)) {
                    alert('El monto excede el saldo de la NCR (' + Number(ncrSeleccionada.saldo).toLocaleString('es-PY') + ')');
                    return;
                }
                // Enviar notacredito al pago
                pago.notacredito = ncrSeleccionada.notacredito;
                await axios.post(getApiUrl('/api/bliqrepard'), pago);
            } else if (tipoPago === 'RET') {
                // Validar campos obligatorios de la retencion
                if (!retencion.nretencion) { alert('Debe ingresar el Nro de Retencion'); return; }
                if (!retencion.timbrado) { alert('Debe ingresar el Timbrado'); return; }
                if (!retencion.venctimb) { alert('Debe ingresar el Vencimiento del Timbrado'); return; }
                if (Number(retencion.totalReten) <= 0) { alert('El Total Retenido debe ser mayor a 0'); return; }

                // Forzar monto a totalReten
                pago.monReten = Number(retencion.totalReten);

                const f = facturaPagoSeleccionada;
                const retencionPayload = {
                    idCliente: f.id_cliente,
                    tipoDoc: retencion.tipoDoc || 'RET',
                    serie: Number(retencion.serie) || 1,
                    idSucursal: f.id_sucursal,
                    boca: String(f.boca),
                    nretencion: Number(retencion.nretencion),
                    timbrado: retencion.timbrado,
                    venctimb: retencion.venctimb,
                    fecha: retencion.fecha,
                    ordenpago: 0,
                    valorSiniva: Number(retencion.valorSiniva) || 0,
                    iva: Number(retencion.iva) || 0,
                    valorTotal: Number(retencion.valorTotal) || 0,
                    impReten: Number(retencion.iva) || 0,
                    pocReten: Number(retencion.pocReten) || 0,
                    monReten: Number(retencion.monReten) || 0,
                    totalReten: Number(retencion.totalReten) || 0,
                    monIva10: Number(retencion.iva) || 0,
                    monIva5: 0,
                    monIva: Number(retencion.monReten) || 0,
                    monRenta: Number(retencion.monRenta) || 0,
                    obs: retencion.obs || ' ',
                    idMoneda: f.id_moneda || 'PYG',
                    cambio: Number(f.cambio) || 1
                };

                // Endpoint unico: registra retencion en fretenciones Y pago en bliqrepard
                await axios.post(getApiUrl('/api/bliqrepard/con-retencion'), {
                    pago,
                    retencion: retencionPayload
                });
            } else {
                await axios.post(getApiUrl('/api/bliqrepard'), pago);
            }
            alert('Pago registrado exitosamente');
            await recargarFacturasYPagos();
            cargarRendiciones();
            setMontoPago(0);
            setCheque({ idBanco: '', nrocheque: '', fechaCheque: obtenerFechaHoy(), vencimientoCheque: obtenerFechaHoy(), obsCheque: '' });
            setBancoSeleccionado(null); setBusquedaBanco('');
            setTarjeta({ idTarjeta: '', nroboleta: '', fechaTarjeta: obtenerFechaHoy(), obsTarjeta: '' });
            setTarjetaSeleccionada(null); setBusquedaTarjeta('');
            setNcrSeleccionada(null); setBusquedaNcr('');
            setRetencion({
                nretencion: '', timbrado: '', venctimb: '', fecha: obtenerFechaHoy(),
                serie: 1, tipoDoc: 'RET',
                valorSiniva: 0, iva: 0, valorTotal: 0,
                pocReten: 30, monReten: 0,
                pocRenta: 0, monRenta: 0,
                totalReten: 0, obs: ''
            });
            // Volver al tipo de pago por defecto (oculta sub-formulario de RET/CHE/TC/NCR)
            setTipoPago('EFE');
        } catch (error) {
            const msg = error.response?.data || 'Error al registrar el pago';
            alert(typeof msg === 'string' ? msg : 'Error al registrar el pago');
        }
    };

    const eliminarPago = async (p) => {
        if (!window.confirm('Eliminar este pago?')) return;
        try {
            await axios.delete(getApiUrl('/api/bliqrepard'), {
                params: { idLiquidacion: p.idLiquidacion, tipoDoc: p.tipoDoc, nfactura: p.nfactura,
                    idTpago: p.idTpago, item: p.item, timbrado: p.timbrado }
            });
            await recargarFacturasYPagos();
            cargarRendiciones();
        } catch (e) {
            const msg = e.response?.data || 'Error al eliminar';
            alert(typeof msg === 'string' ? msg : 'Error al eliminar');
        }
    };

    const cerrarModalCaja = () => {
        setModalCajaAbierto(false);
        setRendicionActiva(null);
        setFacturasPendientes([]);
        setPagosRegistrados([]);
        setFacturaPagoSeleccionada(null);
    };

    // Calcular monto pagado por factura desde pagosRegistrados
    const calcularPagadoFactura = (f) => {
        return pagosRegistrados
            .filter(p => p.timbrado === f.timbrado && p.nfactura === f.nfactura && p.tipoDoc === f.tipo_doc && p.boca === f.boca)
            .reduce((s, p) => {
                const cambio = Number(p.cambio) || 1;
                return s + (Number(p.monEfectivo) + Number(p.monCheque) + Number(p.monCtacte) + Number(p.monTc) +
                    Number(p.monNotacr) + Number(p.monOtros) + Number(p.monReten) + Number(p.monAdelanto) +
                    Number(p.monDifcaja) + Number(p.monVuelto)) / cambio;
            }, 0);
    };

    const exportarExcel = () => {
        const d = rendicionesFiltradas.map(r => ({
            'Liquidacion': r.idLiquidacion, 'Nro Reparto': r.nreparto, 'Fecha': r.fecha ? formatearFecha(r.fecha) : '',
            'Empleado': r.idEmpleado, 'Sucursal': r.idSucursal, 'Deposito': r.idDeposito,
            'Tot Efectivo': r.totEfectivo, 'Tot Cheque': r.totCheque, 'Tot Cta Cte': r.totCtacte,
            'Observaciones': r.obs, 'Estado': r.bEstado
        }));
        const ws = XLSX.utils.json_to_sheet(d); const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Rendiciones'); XLSX.writeFile(wb, 'rendicion_planillas.xlsx');
    };

    // Paginacion
    const indiceUltimo = paginaActual * itemsPorPagina;
    const indicePrimero = indiceUltimo - itemsPorPagina;
    const rendicionesActuales = rendicionesFiltradas.slice(indicePrimero, indiceUltimo);
    const totalPaginas = Math.ceil(rendicionesFiltradas.length / itemsPorPagina);

    return (
        <div className="present-container">
            <div className="header-seccion">
                <h2>Rendicion de Planillas</h2>
                <div className="acciones-header">
                    <input type="text" className="input-busqueda" placeholder="Buscar..." value={busqueda} onChange={(e) => setBusqueda(e.target.value)} />
                    <button className="btn btn-nuevo" onClick={abrirModalNuevo}>+ Nueva Rendicion</button>
                    <button className="btn btn-exportar" onClick={exportarExcel}>Exportar Excel</button>
                </div>
            </div>

            <div className="tabla-container">
                <table className="tabla-datos">
                    <thead><tr>
                        <th>Liquidacion</th><th>Nro Reparto</th><th>Fecha</th><th>Empleado</th><th>Sucursal</th>
                        <th style={{textAlign:'right'}}>Tot Efectivo</th><th style={{textAlign:'right'}}>Tot Cheque</th>
                        <th style={{textAlign:'right'}}>Tot Cta Cte</th><th>Obs</th><th>Estado</th><th>Acc</th>
                    </tr></thead>
                    <tbody>
                        {rendicionesActuales.length === 0 ? (
                            <tr><td colSpan="11" className="sin-datos">No hay rendiciones para mostrar</td></tr>
                        ) : rendicionesActuales.map((r, i) => (
                            <tr key={i}>
                                <td>{r.idLiquidacion}</td><td>{r.nreparto}</td>
                                <td>{r.fecha ? formatearFecha(r.fecha) : ''}</td>
                                <td>{r.idEmpleado}</td><td>{r.idSucursal}</td>
                                <td style={{textAlign:'right'}}>{formatearNumero(r.totEfectivo)}</td>
                                <td style={{textAlign:'right'}}>{formatearNumero(r.totCheque)}</td>
                                <td style={{textAlign:'right'}}>{formatearNumero(r.totCtacte)}</td>
                                <td>{r.obs}</td>
                                <td>{r.bEstado === 'C' ? 'Cerrada' : r.bEstado === ' ' ? 'Abierta' : r.bEstado}</td>
                                <td>
                                    <button onClick={() => abrirModalCaja(r)} className="btn-accion" title="Registrar pagos en caja"
                                        disabled={r.bEstado === 'C'} style={r.bEstado === 'C' ? { opacity: 0.5 } : { color: '#2DCCD3' }}>💰</button>
                                    <button onClick={() => abrirModalRendicion(r)} className="btn-accion"
                                        title={r.bEstado === 'C' ? 'Rendicion cerrada (solo lectura)' : 'Cargar rendición manual'}
                                        disabled={r.bEstado === 'C'} style={r.bEstado === 'C' ? { opacity: 0.5 } : { color: '#0d6efd' }}>📝</button>
                                    <button onClick={() => cerrarPlanilla(r)} className="btn-accion"
                                        title={r.bEstado === 'C' ? 'Rendicion ya cerrada' : 'Cerrar rendicion'}
                                        disabled={r.bEstado === 'C'} style={r.bEstado === 'C' ? { opacity: 0.5 } : { color: '#d97706' }}>🔒</button>
                                    <button onClick={() => window.open(getApiUrl('/api/bliqrepar/imprimir-detalle/' + r.nreparto), '_blank')}
                                        className="btn-accion" title="Imprimir detalle de liquidación (PDF)"
                                        style={{ color: '#6A1B9A' }}>🖨️</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* Paginacion */}
            <div className="paginacion-container">
                <div className="paginacion-info">
                    <span>Mostrando {rendicionesFiltradas.length > 0 ? indicePrimero + 1 : 0} a {Math.min(indiceUltimo, rendicionesFiltradas.length)} de {rendicionesFiltradas.length}</span>
                    <select value={itemsPorPagina} onChange={(e) => { setItemsPorPagina(Number(e.target.value)); setPaginaActual(1); }} className="select-registros">
                        <option value={10}>10</option><option value={20}>20</option><option value={50}>50</option>
                    </select>
                </div>
                <div className="paginacion-controles">
                    <button onClick={() => setPaginaActual(1)} disabled={paginaActual === 1} className="btn-paginacion">|&lt;</button>
                    <button onClick={() => setPaginaActual(p => p - 1)} disabled={paginaActual === 1} className="btn-paginacion">&lt;</button>
                    <button onClick={() => setPaginaActual(p => p + 1)} disabled={paginaActual >= totalPaginas} className="btn-paginacion">&gt;</button>
                    <button onClick={() => setPaginaActual(totalPaginas)} disabled={paginaActual >= totalPaginas} className="btn-paginacion">&gt;|</button>
                </div>
            </div>

            {/* Modal */}
            {modalAbierto && (
                <div className="modal-overlay">
                    <div className="modal-contenido" style={{ maxWidth: '700px', maxHeight: '90vh', overflowY: 'auto' }}>
                        <div className="modal-header">
                            <h3>Nueva Rendicion de Planilla</h3>
                            <button onClick={cerrarModal} className="btn-cerrar">&times;</button>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                                <div>
                                    {/* Nro Reparto */}
                                    <div className="form-group">
                                        <label>Nro Reparto (Planilla) *</label>
                                        <select value={formulario.nreparto} onChange={(e) => {
                                            const nr = nrepartoDisponibles.find(n => n.nreparto === Number(e.target.value));
                                            if (nr) seleccionarNreparto(nr);
                                        }} style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                            <option value="">-- Seleccione planilla disponible --</option>
                                            {nrepartoDisponibles.map(nr => (
                                                <option key={nr.nreparto} value={nr.nreparto}>
                                                    Nro {nr.nreparto} - {nr.fecha ? formatearFecha(nr.fecha) : ''} - {nr.obs || ''}
                                                </option>
                                            ))}
                                        </select>
                                        {nrepartoDisponibles.length === 0 && (
                                            <span style={{ fontSize: '12px', color: '#c62828', marginTop: '4px', display: 'block' }}>
                                                No hay planillas disponibles para rendicion
                                            </span>
                                        )}
                                    </div>

                                    {/* Fecha */}
                                    <div className="form-group">
                                        <label>Fecha</label>
                                        <input type="date" value={formulario.fecha} onChange={(e) => setFormulario(f => ({...f, fecha: e.target.value}))} className="input-fecha" />
                                    </div>

                                    {/* Sucursal */}
                                    <div className="form-group">
                                        <label>Sucursal</label>
                                        <select value={formulario.idSucursal || ''} onChange={(e) => setFormulario(f => ({...f, idSucursal: e.target.value ? Number(e.target.value) : ''}))}
                                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                            <option value="">-- Seleccione --</option>
                                            {sucursales.map(s => (<option key={s.idSucursal} value={s.idSucursal}>{s.idSucursal} - {s.nombre}</option>))}
                                        </select>
                                    </div>
                                </div>
                                <div>
                                    {/* Empleado */}
                                    <div className="form-group">
                                        <label>Empleado</label>
                                        <div className="cuenta-selector" ref={dropdownEmpleadoRef}>
                                            {empleadoSeleccionado ? (
                                                <div className="cuenta-seleccionada">
                                                    <span>{empleadoSeleccionado.idEmpleado} - {empleadoSeleccionado.nombre}</span>
                                                    <button type="button" onClick={() => { setEmpleadoSeleccionado(null); setFormulario(f => ({...f, idEmpleado: ''})); }} className="btn-limpiar">✕</button>
                                                </div>
                                            ) : (
                                                <input type="text" placeholder="Buscar empleado..." value={busquedaEmpleado}
                                                    onChange={(e) => setBusquedaEmpleado(e.target.value)}
                                                    onFocus={() => setDropdownEmpleadoAbierto(true)} className="input-busqueda" />
                                            )}
                                            {dropdownEmpleadoAbierto && !empleadoSeleccionado && (
                                                <div className="cuenta-dropdown">
                                                    {filtrarEmpleados(busquedaEmpleado).map(e => (
                                                        <div key={e.idEmpleado} className="cuenta-item" onClick={() => seleccionarEmpleado(e)}>
                                                            <strong>{e.idEmpleado}</strong> - {e.nombre}
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Deposito */}
                                    <div className="form-group">
                                        <label>Deposito</label>
                                        <select value={formulario.idDeposito || ''} onChange={(e) => setFormulario(f => ({...f, idDeposito: e.target.value ? Number(e.target.value) : ''}))}
                                            style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                            <option value="">-- Seleccione --</option>
                                            {depositos.map(d => (<option key={d.idDeposito} value={d.idDeposito}>{d.idDeposito} - {d.nomDepto}</option>))}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {/* Observaciones */}
                            <div className="form-group">
                                <label>Observaciones</label>
                                <textarea value={formulario.obs} onChange={(e) => setFormulario(f => ({...f, obs: e.target.value}))}
                                    maxLength={40} placeholder="Observaciones" rows={2} style={{ width: '100%', resize: 'vertical' }} />
                            </div>

                            <div className="modal-footer">
                                <button type="button" onClick={cerrarModal} className="btn btn-cancelar">Cancelar</button>
                                <button type="submit" className="btn btn-guardar">Guardar</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* ====== MODAL RENDICION MANUAL (campos ren_) ====== */}
            {modalRendicion && rendRow && (
                <div className="modal-overlay" onClick={() => !guardandoRend && setModalRendicion(false)}>
                    <div className="modal-contenido-grande" style={{ maxWidth: '620px', width: '92vw' }} onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Rendición - Planilla {rendRow.nreparto}</h3>
                            <button onClick={() => setModalRendicion(false)} className="btn-cerrar">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '8px' }}>
                                <button type="button" onClick={igualarRendicion}
                                    style={{ background: '#198754', color: '#fff', border: 'none', borderRadius: '4px', padding: '5px 12px', fontSize: '12px', cursor: 'pointer', fontWeight: 600 }}
                                    title="Copiar los valores calculados a la rendición (diferencia = 0 en los rubros base)">
                                    = Igualar a calculado
                                </button>
                            </div>
                            <table className="tabla-datos" style={{ width: '100%', fontSize: '13px' }}>
                                <thead>
                                    <tr>
                                        <th>Concepto</th>
                                        <th style={{ textAlign: 'right' }}>Calculado</th>
                                        <th style={{ textAlign: 'right' }}>Rendición</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {RENDICION_CAMPOS.map(c => (
                                        <tr key={c.ren}>
                                            <td>{c.label}</td>
                                            <td style={{ textAlign: 'right', color: '#555' }}>{formatearNumero(rendTot[c.tot] || 0)}</td>
                                            <td style={{ textAlign: 'right' }}>
                                                <input type="number" value={rendForm[c.ren] ?? 0}
                                                    onChange={(e) => setRendCampo(c.ren, e.target.value)}
                                                    style={{ width: '130px', textAlign: 'right', padding: '4px 6px', border: '1px solid #ced4da', borderRadius: '4px' }} />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
                                        <td colSpan="2" style={{ textAlign: 'right' }}>Diferencia:</td>
                                        <td style={{ textAlign: 'right', color: calcularDiferenciaRend() === 0 ? '#1b5e20' : '#c62828' }}>
                                            {formatearNumero(calcularDiferenciaRend())}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            <p style={{ fontSize: '11px', color: '#7f8c8d', marginTop: '8px' }}>
                                Los valores <b>Calculados</b> se generan con la carga del detalle. Cargá la <b>Rendición</b> hasta que la diferencia sea 0.
                            </p>
                            <div className="form-actions">
                                <button type="button" className="btn-secondary" onClick={() => setModalRendicion(false)} disabled={guardandoRend}>Cancelar</button>
                                <button type="button" className="btn-primary" onClick={guardarRendicion} disabled={guardandoRend}>
                                    {guardandoRend ? 'Guardando...' : 'Guardar'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ====== MODAL CAJA - REGISTRO DE PAGOS ====== */}
            {modalCajaAbierto && rendicionActiva && (
                <div className="modal-overlay">
                    <div className="modal-contenido-grande" style={{ maxWidth: '1200px' }}>
                        <div className="modal-header">
                            <h3>Caja - Liquidacion {rendicionActiva.idLiquidacion} | Reparto {rendicionActiva.nreparto}</h3>
                            <button onClick={cerrarModalCaja} className="btn-cerrar">&times;</button>
                        </div>
                        <div className="modal-body">
                            {/* Facturas pendientes */}
                            <div className="form-section">
                                <h3>Facturas Pendientes</h3>
                                <table className="tabla-datos" style={{ fontSize: '13px' }}>
                                    <thead>
                                        <tr>
                                            <th>Sel</th><th>Numero</th><th>Timbrado</th><th>Tipo</th>
                                            <th>Cliente</th><th>Vto</th>
                                            <th style={{textAlign:'right'}}>Total</th>
                                            <th style={{textAlign:'right'}}>Pagos Prev</th>
                                            <th style={{textAlign:'right'}}>Disponible</th>
                                            <th>Mon</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {facturasPendientes.length === 0 ? (
                                            <tr><td colSpan="10" className="sin-datos">No hay facturas pendientes</td></tr>
                                        ) : facturasPendientes.map((f, i) => (
                                            <tr key={i}
                                                onClick={() => seleccionarFacturaPago(f)}
                                                style={{ cursor: 'pointer',
                                                    backgroundColor: facturaPagoSeleccionada &&
                                                        facturaPagoSeleccionada.timbrado === f.timbrado &&
                                                        facturaPagoSeleccionada.nfactura === f.nfactura ? '#EDF1FB' : ''
                                                }}>
                                                <td>
                                                    <input type="radio" name="facturaSel" checked={
                                                        facturaPagoSeleccionada &&
                                                        facturaPagoSeleccionada.timbrado === f.timbrado &&
                                                        facturaPagoSeleccionada.nfactura === f.nfactura
                                                    } onChange={() => seleccionarFacturaPago(f)} />
                                                </td>
                                                <td>{String(f.id_sucursal).padStart(3,'0')}-{String(f.boca).padStart(3,'0')}-{f.nfactura}</td>
                                                <td>{f.timbrado}</td>
                                                <td>{f.tipo_doc}</td>
                                                <td>{f.nom_cliente}</td>
                                                <td>{f.vence ? formatearFecha(f.vence) : ''}</td>
                                                <td style={{textAlign:'right'}}>{formatearNumero(f.mon_total)}</td>
                                                <td style={{textAlign:'right', color: '#7f8c8d'}}>{formatearNumero(f.pagos_previos)}</td>
                                                <td style={{textAlign:'right', fontWeight:'bold', color:'#001A70'}}>{formatearNumero(f.disponible)}</td>
                                                <td>{f.id_moneda}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* Form de pago */}
                            {facturaPagoSeleccionada && (
                                <div className="form-section" style={{ marginTop: '15px', backgroundColor: '#EDF1FB', padding: '15px', borderRadius: '8px' }}>
                                    <h3 style={{ marginTop: 0 }}>Registrar Pago - Factura {facturaPagoSeleccionada.nfactura}</h3>
                                    <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr auto', gap: '10px', alignItems: 'end' }}>
                                        <div className="form-group">
                                            <label>Tipo de Pago *</label>
                                            <select value={tipoPago} onChange={(e) => setTipoPago(e.target.value)}
                                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }}>
                                                {TIPOS_PAGO.map(t => (
                                                    <option key={t.codigo} value={t.codigo}>{t.codigo} - {t.nombre}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <label>Monto *</label>
                                            <input type="number" value={montoPago} min="0" step="100"
                                                onChange={(e) => setMontoPago(Number(e.target.value))}
                                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                        </div>
                                        <div className="form-group">
                                            <label>Disponible</label>
                                            <input type="text" value={formatearNumero(facturaPagoSeleccionada.disponible || facturaPagoSeleccionada.saldo)} readOnly
                                                style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', backgroundColor: '#f0f0f0', textAlign: 'right' }} />
                                        </div>
                                        <div className="form-group">
                                            <button type="button" onClick={registrarPago} className="btn btn-nuevo" style={{ marginTop: '5px' }}>
                                                + Registrar Pago
                                            </button>
                                        </div>
                                    </div>

                                    {/* Sub-formulario de cheque (solo si tipo CHE) */}
                                    {tipoPago === 'CHE' && (
                                        <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#fff', border: '2px solid #2DCCD3', borderRadius: '6px' }}>
                                            <h4 style={{ marginTop: 0, color: '#001A70' }}>Datos del Cheque</h4>
                                            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '10px' }}>
                                                <div className="form-group">
                                                    <label>Banco *</label>
                                                    <div className="cuenta-selector" ref={dropdownBancoRef}>
                                                        {bancoSeleccionado ? (
                                                            <div className="cuenta-seleccionada">
                                                                <span>{bancoSeleccionado.idBco} - {bancoSeleccionado.nomBco}</span>
                                                                <button type="button" onClick={() => { setBancoSeleccionado(null); setCheque(c => ({...c, idBanco: ''})); }} className="btn-limpiar">✕</button>
                                                            </div>
                                                        ) : (
                                                            <input type="text" placeholder="Buscar banco..." value={busquedaBanco}
                                                                onChange={(e) => setBusquedaBanco(e.target.value)}
                                                                onFocus={() => setDropdownBancoAbierto(true)} className="form-input" />
                                                        )}
                                                        {dropdownBancoAbierto && !bancoSeleccionado && (
                                                            <div className="cuenta-dropdown">
                                                                {filtrarBancos(busquedaBanco).map(b => (
                                                                    <div key={b.idBco} className="cuenta-item" onClick={() => seleccionarBanco(b)}>
                                                                        <strong>{b.idBco}</strong> - {b.nomBco}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label>Nro Cheque *</label>
                                                    <input type="number" value={cheque.nrocheque} onChange={(e) => setCheque({...cheque, nrocheque: e.target.value})}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Fecha</label>
                                                    <input type="date" value={cheque.fechaCheque} onChange={(e) => setCheque({...cheque, fechaCheque: e.target.value})}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Vencimiento *</label>
                                                    <input type="date" value={cheque.vencimientoCheque} onChange={(e) => setCheque({...cheque, vencimientoCheque: e.target.value})}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                            </div>
                                            <div className="form-group" style={{ marginTop: '8px' }}>
                                                <label>Observaciones del cheque</label>
                                                <input type="text" value={cheque.obsCheque} onChange={(e) => setCheque({...cheque, obsCheque: e.target.value})}
                                                    maxLength={50} placeholder="Observaciones (opcional)"
                                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                            </div>
                                        </div>
                                    )}

                                    {/* Sub-formulario de tarjeta (solo si tipo TC) */}
                                    {tipoPago === 'TC' && (
                                        <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#fff', border: '2px solid #C5299B', borderRadius: '6px' }}>
                                            <h4 style={{ marginTop: 0, color: '#001A70' }}>Datos de la Tarjeta</h4>
                                            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '10px' }}>
                                                <div className="form-group">
                                                    <label>Tarjeta *</label>
                                                    <div className="cuenta-selector" ref={dropdownTarjetaRef}>
                                                        {tarjetaSeleccionada ? (
                                                            <div className="cuenta-seleccionada">
                                                                <span>{tarjetaSeleccionada.idTarjeta} - {tarjetaSeleccionada.nomTarjeta}</span>
                                                                <button type="button" onClick={() => { setTarjetaSeleccionada(null); setTarjeta(t => ({...t, idTarjeta: ''})); }} className="btn-limpiar">✕</button>
                                                            </div>
                                                        ) : (
                                                            <input type="text" placeholder="Buscar tarjeta..." value={busquedaTarjeta}
                                                                onChange={(e) => setBusquedaTarjeta(e.target.value)}
                                                                onFocus={() => setDropdownTarjetaAbierto(true)} className="form-input" />
                                                        )}
                                                        {dropdownTarjetaAbierto && !tarjetaSeleccionada && (
                                                            <div className="cuenta-dropdown">
                                                                {filtrarTarjetas(busquedaTarjeta).map(t => (
                                                                    <div key={t.idTarjeta} className="cuenta-item" onClick={() => seleccionarTarjetaSel(t)}>
                                                                        <strong>{t.idTarjeta}</strong> - {t.nomTarjeta}
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label>Nro Boleta *</label>
                                                    <input type="number" value={tarjeta.nroboleta} onChange={(e) => setTarjeta({...tarjeta, nroboleta: e.target.value})}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Fecha</label>
                                                    <input type="date" value={tarjeta.fechaTarjeta} onChange={(e) => setTarjeta({...tarjeta, fechaTarjeta: e.target.value})}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                            </div>
                                            <div className="form-group" style={{ marginTop: '8px' }}>
                                                <label>Observaciones de la boleta</label>
                                                <input type="text" value={tarjeta.obsTarjeta} onChange={(e) => setTarjeta({...tarjeta, obsTarjeta: e.target.value})}
                                                    maxLength={50} placeholder="Observaciones (opcional)"
                                                    style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                            </div>
                                        </div>
                                    )}

                                    {/* Sub-formulario de NCR (solo si tipo NCR) */}
                                    {tipoPago === 'NCR' && (
                                        <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#fff', border: '2px solid #856404', borderRadius: '6px' }}>
                                            <h4 style={{ marginTop: 0, color: '#856404' }}>Nota de Credito a aplicar</h4>
                                            {ncrDisponibles.length === 0 ? (
                                                <div style={{ padding: '10px', color: '#c62828', fontStyle: 'italic' }}>
                                                    El cliente no tiene notas de credito con saldo disponible.
                                                </div>
                                            ) : (
                                                <>
                                                    <div className="form-group">
                                                        <label>Seleccionar NCR *</label>
                                                        <div className="cuenta-selector" ref={dropdownNcrRef}>
                                                            {ncrSeleccionada ? (
                                                                <div className="cuenta-seleccionada">
                                                                    <span>
                                                                        NCR <strong>{ncrSeleccionada.notacredito}</strong> ({ncrSeleccionada.timbrado})
                                                                        | Saldo: <strong>{Number(ncrSeleccionada.saldo).toLocaleString('es-PY')}</strong>
                                                                        | Tipo: {ncrSeleccionada.tipo_notacr || '-'}
                                                                    </span>
                                                                    <button type="button" onClick={() => { setNcrSeleccionada(null); }} className="btn-limpiar">✕</button>
                                                                </div>
                                                            ) : (
                                                                <input type="text" placeholder="Buscar NCR por numero, timbrado o comprobante..." value={busquedaNcr}
                                                                    onChange={(e) => setBusquedaNcr(e.target.value)}
                                                                    onFocus={() => setDropdownNcrAbierto(true)} className="form-input" />
                                                            )}
                                                            {dropdownNcrAbierto && !ncrSeleccionada && (
                                                                <div className="cuenta-dropdown">
                                                                    {filtrarNCR(busquedaNcr).map((n, i) => (
                                                                        <div key={i} className="cuenta-item" onClick={() => seleccionarNCR(n)}>
                                                                            <strong>NCR {n.notacredito}</strong> | Timb {n.timbrado}
                                                                            {' | '}<span style={{ color: '#001A70' }}>Saldo: {Number(n.saldo).toLocaleString('es-PY')}</span>
                                                                            {' | '}<span style={{ color: '#7f8c8d', fontSize: '11px' }}>Tipo: {n.tipo_notacr || '-'}</span>
                                                                            {n.comprobante && <span style={{ color: '#7f8c8d', fontSize: '11px' }}> | {n.comprobante}</span>}
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                        </div>
                                    )}

                                    {/* Sub-formulario de RETENCION (solo si tipo RET) */}
                                    {tipoPago === 'RET' && (
                                        <div style={{ marginTop: '15px', padding: '12px', backgroundColor: '#fff', border: '2px solid #5e35b1', borderRadius: '6px' }}>
                                            <h4 style={{ marginTop: 0, color: '#5e35b1' }}>
                                                Datos de la Retencion
                                            </h4>

                                            {/* Fila 1: identificacion */}
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                                                <div className="form-group">
                                                    <label>Nro Retencion *</label>
                                                    <input type="number" value={retencion.nretencion}
                                                        onChange={(e) => setRetencion(r => ({ ...r, nretencion: e.target.value }))}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Timbrado *</label>
                                                    <input type="text" maxLength={16} value={retencion.timbrado}
                                                        onChange={(e) => setRetencion(r => ({ ...r, timbrado: e.target.value }))}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Venc. Timbrado *</label>
                                                    <input type="date" value={retencion.venctimb}
                                                        onChange={(e) => setRetencion(r => ({ ...r, venctimb: e.target.value }))}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Fecha</label>
                                                    <input type="date" value={retencion.fecha}
                                                        onChange={(e) => setRetencion(r => ({ ...r, fecha: e.target.value }))}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Serie</label>
                                                    <input type="number" value={retencion.serie}
                                                        onChange={(e) => setRetencion(r => ({ ...r, serie: Number(e.target.value) || 1 }))}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                            </div>

                                            {/* Fila 2: bases de calculo */}
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                                                <div className="form-group">
                                                    <label>Valor sin IVA</label>
                                                    <input type="number" value={retencion.valorSiniva} step="100"
                                                        onChange={(e) => recalcularRetencion({ valorSiniva: Number(e.target.value) })}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', textAlign: 'right' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>IVA</label>
                                                    <input type="number" value={retencion.iva} step="100"
                                                        onChange={(e) => recalcularRetencion({ iva: Number(e.target.value) })}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', textAlign: 'right' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Valor Total</label>
                                                    <input type="number" value={retencion.valorTotal} step="100"
                                                        onChange={(e) => recalcularRetencion({ valorTotal: Number(e.target.value) })}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', textAlign: 'right' }} />
                                                </div>
                                            </div>

                                            {/* Fila 3: retencion IVA */}
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: '10px', marginBottom: '10px' }}>
                                                <div className="form-group">
                                                    <label>% Reten. IVA</label>
                                                    <input type="number" value={retencion.pocReten} min="0" max="100" step="1"
                                                        onChange={(e) => recalcularRetencion({ pocReten: Number(e.target.value) })}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', textAlign: 'right' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Monto IVA Reten.</label>
                                                    <input type="number" value={retencion.monReten} step="100"
                                                        onChange={(e) => recalcularRetencion({ monReten: Number(e.target.value) })}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', textAlign: 'right' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>% Reten. Renta</label>
                                                    <input type="number" value={retencion.pocRenta} min="0" max="100" step="0.1"
                                                        onChange={(e) => recalcularRetencion({ pocRenta: Number(e.target.value) })}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', textAlign: 'right' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Monto Renta Reten.</label>
                                                    <input type="number" value={retencion.monRenta} step="100"
                                                        onChange={(e) => recalcularRetencion({ monRenta: Number(e.target.value) })}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px', textAlign: 'right' }} />
                                                </div>
                                            </div>

                                            {/* Fila 4: total + obs */}
                                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 3fr', gap: '10px', alignItems: 'end' }}>
                                                <div className="form-group">
                                                    <label style={{ fontWeight: 'bold' }}>TOTAL RETENIDO</label>
                                                    <input type="text" value={formatearNumero(retencion.totalReten)} readOnly
                                                        style={{ width: '100%', padding: '8px', border: '2px solid #5e35b1', borderRadius: '5px', backgroundColor: '#f3e5f5', textAlign: 'right', fontWeight: 'bold', fontSize: '15px' }} />
                                                </div>
                                                <div className="form-group">
                                                    <label>Observaciones</label>
                                                    <input type="text" value={retencion.obs} maxLength={250}
                                                        onChange={(e) => setRetencion(r => ({ ...r, obs: e.target.value }))}
                                                        style={{ width: '100%', padding: '8px', border: '1px solid #ddd', borderRadius: '5px' }} />
                                                </div>
                                            </div>

                                            <div style={{ marginTop: '8px', fontSize: '12px', color: '#7f8c8d', fontStyle: 'italic' }}>
                                                * Al pulsar "+ Registrar Pago" se guarda la retencion en fretenciones y el pago en bliqrepard (tipo_pago = RET).
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Pagos registrados */}
                            <div className="form-section" style={{ marginTop: '20px' }}>
                                <h3>Pagos Registrados ({pagosRegistrados.length})</h3>
                                <table className="tabla-datos" style={{ fontSize: '13px' }}>
                                    <thead>
                                        <tr>
                                            <th>Item</th><th>Numero Factura</th><th>Timbrado</th><th>Tipo Doc</th>
                                            <th>T.Pago</th><th style={{textAlign:'right'}}>Monto</th><th>Acc</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {pagosRegistrados.length === 0 ? (
                                            <tr><td colSpan="7" className="sin-datos">Sin pagos registrados</td></tr>
                                        ) : pagosRegistrados.map((p, i) => {
                                            const monto = Number(p.monEfectivo) + Number(p.monCheque) + Number(p.monCtacte) + Number(p.monTc) +
                                                Number(p.monNotacr) + Number(p.monOtros) + Number(p.monReten) + Number(p.monAdelanto) +
                                                Number(p.monDifcaja) + Number(p.monVuelto);
                                            return (
                                                <tr key={i}>
                                                    <td>{p.item}</td>
                                                    <td>{String(p.idSucursal).padStart(3,'0')}-{String(p.boca).padStart(3,'0')}-{p.nfactura}</td>
                                                    <td>{p.timbrado}</td>
                                                    <td>{p.tipoDoc}</td>
                                                    <td>{p.idTpago}</td>
                                                    <td style={{textAlign:'right'}}>{formatearNumero(monto)}</td>
                                                    <td><button type="button" onClick={() => eliminarPago(p)} className="btn-accion" title="Eliminar pago">🗑️</button></td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>

                            <div className="form-actions" style={{ marginTop: '15px' }}>
                                <button type="button" onClick={cerrarModalCaja} className="btn-primary">Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default BLiqRepar;
